import { ensure, stringType, TType } from "types";

import { configIdType, IId } from "@/core/api";
import { ICodelist } from "@/data/codelists";

export type ILanguage = ICodelist["code"];

interface ILanguageParameter {
  topLanguage: boolean;
}

export interface ILanguagesCodelist extends ICodelist<ILanguageParameter> {}

export interface ITranslatedLanguagesCodelist extends ILanguagesCodelist {
  value: string;
}

export interface ILanguageWithLevel extends IId {
  language: ILanguage;
  level: ICodelist["code"];
}

const configLanguageWIthLevelType: TType<ILanguageWithLevel> = {
  ...configIdType,
  language: stringType(null),
  level: stringType(null),
};

export const languageWithLevelType = ensure(configLanguageWIthLevelType);
